import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { green, redDefault } from 'app/components/ThemeProvider/colors';

const LogoutIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 18 18" sx={{ height: '18px', width: '18px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M12 12.75L15.75 9M15.75 9L12 5.25M15.75 9H6.75M6.75 2.25H5.85C4.58988 2.25 3.95982 2.25 3.47852 2.49524C3.05516 2.71095 2.71095 3.05516 2.49524 3.47852C2.25 3.95982 2.25 4.58988 2.25 5.85V12.15C2.25 13.4101 2.25 14.0402 2.49524 14.5215C2.71095 14.9448 3.05516 15.289 3.47852 15.5048C3.95982 15.75 4.58988 15.75 5.85 15.75H6.75"
        stroke={props.color === 'warning' ? redDefault : green}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default LogoutIcon;
